import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { inputClass } from './FormField';
interface FilterSelectProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  options: {
    value: string;
    label: string;
  }[];
  disabled?: boolean;
}
export function FilterSelect({
  id,
  label,
  value,
  onChange,
  placeholder,
  options,
  disabled
}: FilterSelectProps) {
  return <div data-id="element-236" data-mp="ms5t4tnw6sn3">
      <label htmlFor={id} className="mb-1.5 block text-xs font-medium text-muted" data-id="element-237" data-mp="mrw9dntfxhpu">
        {label}
      </label>
      <div className="relative" data-id="element-238" data-mp="irvobkbu689t">
        <select id={id} value={value} disabled={disabled} onChange={e => onChange(e.target.value)} className={`${inputClass} appearance-none pr-9 disabled:cursor-not-allowed disabled:opacity-50 ${value ? 'border-neon-electric' : ''}`} data-id="element-239" data-mp="wpadqp23ag1s">
          <option value="" data-id="element-240" data-mp="234kum3xayf77">{placeholder}</option>
          {options.map(o => <option key={o.value} value={o.value} data-id="element-241" data-mp="13l0wmyvmmfs5">
              {o.label}
            </option>)}
        </select>
        <ChevronDownIcon className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted" aria-hidden="true" data-id="element-242" data-mp="18iasoxditpoy" />
      </div>
    </div>;
}